(window as any).process = { browser: true };
import 'zone.js/dist/zone'; 
